export const CurrencyRateLabelTextHelper = {
    getLabelText: {
        currencyRateId: 'Currency Rate ID',
        currencyCodeFrom: 'Currency From',
        currencyCodeTo: 'Currency To',
        exchangeRate: 'Exchange Rate',
        dateEffectiveOn: 'Effective Date',
        dateCreateAt: 'Create date',
        dateModifyAt: 'Modify date',
        dateEffectiveOnFrom: 'Effective Date From',
        dateEffectiveOnTo: 'Effective Date To',
        action: 'Action'
    }
};
